import React from 'react';
import Webcam from 'react-webcam';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';

import {MODALS} from 'ducks/modals';
import {
  verifyAgreementUserInternalAvatarUpload,
  REFETCH_AVATARS_DELAY
} from 'ducks/agreementUsers';
import {composeActions, delayedAction} from 'ducks/common';
import {uploadFile} from 'ducks/files';

import {signAgreementUserInternalAvatar} from 'sdk/agreementUsers';

import {requestBlob} from 'sdk';

import takePhotoImage from 'assets/icons/takePhoto.svg';

import './styles.css';

class AgreementUserTakePhotoModal extends React.Component<any> {
  webcamRef: any = React.createRef();

  state = {
    photo: null,
    showError: false,
    submitting: false
  };

  //In the implementation they expect a function that accepts ref; I cannot use `ref={this.webcamRef}`
  setRef = webcam => {
    this.webcamRef = webcam;
  };

  capturePhoto = () => {
    const photo = this.webcamRef.getScreenshot();
    this.setState({photo});
  };

  uploadFile = file => {
    const {data: {agreementUserId, locationRef, extraActions}} = this.props;

    const finishUploadingAction = () =>
      delayedAction({
        delay: REFETCH_AVATARS_DELAY,
        action: () =>
          composeActions([
            ...this.props.closeModalExtraActions,
            ...extraActions
          ])
      });

    const storeIdentifierAction = identifier =>
      verifyAgreementUserInternalAvatarUpload({
        identifier,
        agreementUserId
      });

    const signData = {
      filename: file.name,
      fileType: file.type,
      location: locationRef,
      agreementUserId
    };

    this.props.uploadFile({
      file,
      signSdk: signAgreementUserInternalAvatar,
      signData,
      finishUploadingAction,
      storeIdentifierAction
    });
  };

  imageBase64ToFile = (imageBase64, callback) => {
    requestBlob(imageBase64, {}, {}, true)
      .then(response => {
        const file = new File([response.data], 'MemberAvatar', {
          type: 'image/jpeg'
        });
        this.setState({showError: false, submitting: true}, () =>
          callback(file)
        );
      })
      .catch(() => {
        this.setState({showError: true, submitting: false});
      });
  };

  uploadPhoto = () => {
    this.imageBase64ToFile(this.state.photo, this.uploadFile);
  };

  deletePhoto = () => {
    this.setState({photo: null});
  };

  render() {
    const {showError, photo, submitting} = this.state;

    // The width and the height of the camera focus
    const videoConstraints = {
      width: 1030,
      height: 720,
      facingMode: 'user'
    };

    return (
      <Modal
        className="AgreementUserTakePhotoModal"
        modalOverlayClassName="AgreementUserTakePhotoModal__overlay"
        show={true}
        type={Modal.SUB_MEDIUM}
        onClose={this.props.closeModal}>
        <Modal.Header>
          <div className="AgreementUserTakePhotoModal__header">
            <img src={takePhotoImage} />
            <div className="AgreementUserTakePhotoModal__header__text">
              Take a photo
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {!photo && (
            <Webcam
              ref={this.setRef}
              audio={false}
              screenshotFormat="image/jpeg"
              height={490}
              width={700}
              videoConstraints={videoConstraints}
            />
          )}
          {photo && (
            <div className="AgreementUserTakePhotoModal__preview">
              <img src={photo} alt="photo" />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {showError && <ErrorBlock>Upload did not succeed</ErrorBlock>}
          <Button
            white
            className="AgreementUserTakePhotoModal__cancel_button"
            onClick={this.props.closeModal}>
            Cancel
          </Button>
          {!photo && (
            <Button
              blue
              className="AgreementUserTakePhotoModal__takePhoto_button"
              onClick={this.capturePhoto}>
              Take Photo
            </Button>
          )}
          {!photo && <div className="AgreementUserTakePhotoModal__spacer" />}
          {photo && (
            <Button
              white
              className="AgreementUserTakePhotoModal__retake_button"
              onClick={this.deletePhoto}>
              Retake
            </Button>
          )}
          {photo && (
            <Button
              blue
              className="AgreementUserTakePhotoModal__upload_button"
              isLoading={submitting}
              onClick={this.uploadPhoto}>
              Save
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = () => ({});

const mapDispatchToProps = {
  uploadFile
};

export default withModal(
  MODALS.AGREEMENT_USER_TAKE_PHOTO,
  mapStateToModalData,
  mapDispatchToProps
)(AgreementUserTakePhotoModal);
